import api from './api';

const appealsConfig = { system: 'appeals' };

export const DonationsAPI = {
  getDonationBookings: (params = {}) =>
    api.get('/donation_bookings', { params, ...appealsConfig }),
  updateDonationStatus: (id, payload) =>
    api.patch(`/donation_bookings/${id}/status`, payload, appealsConfig)
};
